import { render } from "./getSyndrome.vue?vue&type=template&id=7845944d&scoped=true"
import script from "./getSyndrome.vue?vue&type=script&lang=js"
export * from "./getSyndrome.vue?vue&type=script&lang=js"

import "./getSyndrome.vue?vue&type=style&index=0&id=7845944d&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7845944d"]])

export default __exports__